import { render, staticRenderFns } from "./ludimos-technology-featured-in-cgtn.vue?vue&type=template&id=87232f8a&scoped=true&"
var script = {}
import style0 from "./ludimos-technology-featured-in-cgtn.vue?vue&type=style&index=0&id=87232f8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87232f8a",
  null
  
)

export default component.exports